module.exports = __webpack_public_path__ + "static/media/Beach6.dd9cf571.jpg";